/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import {
  setNihPositiveStrokeScaleQuestionAnswers,
  setRaceStrokeScaleQuestionAnswers,
  setStrokeScaleOptions,
  setStrokeScaleScoreOptions,
} from '../store/options.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { PCRConstants } from '../../pcr/store/pcr.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import {
  IStrokeScaleScoreOptions,
  IStrokeScaleScoreResponse,
  IStrokeScaleValues,
} from '../../vitals/store/vitals.types'
import { sort } from '../../../utilities/options.util'

function getStokeScaleScoreQuesAns(strokeScaleScoreResponseOptions: IStrokeScaleScoreOptions, optionId: number) {
  const questions = Array.from(
    new Set(
      strokeScaleScoreResponseOptions.map((option) => {
        if (option.scaleId === optionId) {
          return option.oracleName
        }
      })
    )
  )
  const questionToAnswerOptions: IStrokeScaleValues = []
  questions.forEach((question) => {
    if (question) {
      const answerOptions = strokeScaleScoreResponseOptions.filter((option) => option.oracleName === question)
      answerOptions.map((option) => (option.name = option.id + ':' + option.name))
      questionToAnswerOptions.push({ question, options: answerOptions })
    }
  })
  return questionToAnswerOptions
}

export function* getStrokeScaleAndScore() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const strokeScaleScoreResponse: IStrokeScaleScoreResponse = yield call([
      vitalsService,
      vitalsService.getStrokeScaleScore,
    ])
    yield put(setStrokeScaleScoreOptions(strokeScaleScoreResponse.entity))
    const strokeScaleResponse: IOptionsResponse = yield call([vitalsService, vitalsService.getStrokeScale])
    const { entity } = strokeScaleResponse
    if (strokeScaleScoreResponse.entity) {
      const scoreIds = Array.from(new Set(strokeScaleScoreResponse.entity.map((option) => option.scaleId)))
      const nihPositiveStrokeScaleScoreQAOptions = getStokeScaleScoreQuesAns(strokeScaleScoreResponse.entity, 9)
      const raceStrokeScaleScoreQAOptions = getStokeScaleScoreQuesAns(strokeScaleScoreResponse.entity, 18)
      yield put(setNihPositiveStrokeScaleQuestionAnswers(nihPositiveStrokeScaleScoreQAOptions))
      yield put(setRaceStrokeScaleQuestionAnswers(raceStrokeScaleScoreQAOptions))
      entity.map((option) => {
        if (option.id && scoreIds.includes(option.id)) {
          option.dataAttribute1 = true
        } else {
          option.dataAttribute1 = false
        }
      })
    }
    sort(entity)
    yield put(setStrokeScaleOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getStrokeScaleAndScore() error: ${e}`))
  }
}

export function* getStrokeScaleAndScoreSaga() {
  yield takeLatest([PCRConstants.CREATE_PCR], getStrokeScaleAndScore)
}
